// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31gm6","footer":"Form_footer__1ljJY"};